<template>
  <div class="text-page">
    <a v-on:click="leavePage()">
      <img
        class="close-icon"
        src="../assets/img/close-icon.svg"
      />
    </a>
    <h2 class="h2-custom">Litteratur</h2>

      <div class="mt2">Anon. 2023. 
        <a href="https://brage.nina.no/nina-xmlui/handle/11250/3074251" target="_blank">Status for norske laksebestander i 2023 </a> 
        <i>Rapport fra Vitenskapelig råd for lakseforvaltning nr. 18, 124 s</i>
      </div>
      <div class="mt2">Diserud, O.H., Hindar, K., Karlsson, S., Glover, K.A. & Skaala, Ø. 2023. 
        <a href="https://brage.nina.no/nina-xmlui/handle/11250/3108558" target="_blank">Genetisk påvirkning av rømt oppdrettslaks på ville laksebestander – oppdatert status 2023</a>. 
        <i>NINA Rapport 2393. Norsk institutt for naturforskning.</i>
      </div>
      <div class="mt2">Glover, K.A., Pertoldi, P., Besnier, F., Wennevik, V., Kent, M.P. & Skaala, Ø. 2013. 
        <a href="https://bmcgenomdata.biomedcentral.com/articles/10.1186/1471-2156-14-74" target="_blank">Atlantic salmon populations invaded by farmed escapees: quantifying genetic introgression with a Bayesian approach and SNPs</a>. 
        <i>BMC Genetics, 14: 7</i>
      </div>
      <div class="mt2">Karlsson, S., Moen, T., Lien, S., Glover, K. & Hindar, K. 2011. 
        <a href="https://brage.nina.no/nina-xmlui/handle/11250/2593228" target="_blank">Generic genetic differences between farmed and wild Atlantic salmon identified from a 7K SNP-chip.</a> 
        <i>Molecular Ecology Resources 11 (Suppl. 1): 247-253.</i>
      </div> 
      <div class="mt2">Karlsson, S., Diserud, O.H., Moen, T. & Hindar, K. 2014. 
        <a href="https://nmbu.brage.unit.no/nmbu-xmlui/handle/11250/2460985" target="_blank">A standardized method for quantifying unidirectional genetic introgression</a>.
        <i>Ecology & Evolution 4: 3256-3263. </i>
      </div>
      <div class="mt2">Karlsson, S., Diserud, O.H., Fiske, P. & Hindar, K. 2016. 
        <a href="https://nmbu.brage.unit.no/nmbu-xmlui/handle/11250/2460985" target="_blank">Widespread genetic introgression of escaped farmed Atlantic salmon in wild salmon populations.</a> 
        <i>ICES Journal of Marine Science 73: 2488– 2498.</i>
      </div>
    
  </div>
</template>

<script>
import router from "../router.js";

export default {
  name: "Litterature",
  props: {
    msg: String
  },
  methods: {
    leavePage() {
      router.push({ name: "watercourses" });
    }
  }
};
</script>